module.exports = __webpack_public_path__ + "img/head_15.111e10f8.png";